import { render, staticRenderFns } from "./PersonCrud.vue?vue&type=template&id=e53704de"
import script from "./PersonCrud.vue?vue&type=script&lang=js"
export * from "./PersonCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports